export const blockIconsHomeNestHeatLinkGen3New = (
	<span className='material-symbols-outlined'>nest_heat_link_gen_3</span>
);
